// extracted by mini-css-extract-plugin
export default {"header":"ProgressToNet_header__RvEO-","subHeader":"ProgressToNet_subHeader__ZQzF8"};